import { render, staticRenderFns } from "./WarehousesCarantineList.vue?vue&type=template&id=42e1b86a&"
import script from "./WarehousesCarantineList.vue?vue&type=script&lang=ts&"
export * from "./WarehousesCarantineList.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousesCarantineList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports